
import { useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

// Add missing imports
export { ChevronDown };

export const useHeaderState = (userRole: string = 'reader') => {
  const location = useLocation();
  const currentPath = location.pathname;
  
  // Determine if the user is a journalist based on their role
  // Allow both 'journalist' and 'admin' roles to access journalist features
  const isJournalist = userRole === 'journalist' || userRole === 'admin';
  
  // Determine mode based on the current path
  // Any path starting with /dashboard is considered creator mode
  const isInCreatorMode = currentPath.startsWith('/dashboard');
  // Otherwise, we're in reader mode
  const isInReaderMode = !isInCreatorMode;
  
  console.log('useHeaderState - Path:', currentPath);
  console.log('useHeaderState - User role:', userRole);
  console.log('useHeaderState - Is journalist:', isJournalist);
  console.log('useHeaderState - Is in creator mode:', isInCreatorMode);
  console.log('useHeaderState - Is in reader mode:', isInReaderMode);
  
  return {
    isJournalist,
    isInReaderMode,
    isInCreatorMode
  };
};
